import m from "../../geodata/es2015/czechiaLow";
window.am4geodata_czechiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/czechiaLow.js
// module id = null
// module chunks = 